import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const IconDottedLineSm2 = ({ className }) => (
  <svg className={classNames('dotted-line-sm-2 position-absolute d-none d-sm-block d-lg-none', className)} width="300" height="165" viewBox="0 0 452 209" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M446 1V1C457.897 26.6593 439.159 56 410.876 56H390.726C376.833 56 363.527 61.6043 353.821 71.5443L345.381 80.1871C325.264 100.788 295.653 109.035 267.783 101.798L246.36 96.2353C200.171 84.2421 151.608 104.152 127.13 145.116V145.116C111.748 170.859 86.3076 189.001 56.9583 195.158L0.5 207" stroke="#FDAE39" strokeWidth="4" strokeDasharray="2 2" />
  </svg>
);

IconDottedLineSm2.propTypes = {
  className: PropTypes.string,
};

IconDottedLineSm2.defaultProps = {
  className: '',
};
